// Test IDs for summary components

export const SUMMARY_TEST_IDS = {
  // Summary main
  HEADER: 'summary-header',
  SECTION_TITLE: 'summary-section-title',
  SAVE_FOR_LATER_BTN: 'summary-save-for-later-btn',

  // Footer
  FOOTER_CONTAINER: 'summary-footer-container',
  STICKY_FOOTER_CONTAINER: 'summary-sticky-footer-container',
  FOOTER_DELIVERY: 'summary-footer-delivery',
  STICKY_FOOTER_DELIVERY: 'summary-sticky-footer-delivery',
  FOOTER_PRICE: 'summary-footer-price',
  STICKY_FOOTER_PRICE: 'summary-sticky-footer-price',

  // Finish in store
  FINISH_IN_STORE_HEADER: 'finish-in-store-header',
  BOOKING_TOOL_BTN: 'booking-tool-btn',
  BOOKING_TOOL_HEADER: 'booking-tool-header',
  BOOKING_TOOL_DESCRIPTION: 'booking-tool-description',
  WALK_IN_ANYTIME_BTN: 'walk-in-anytime-btn',
  WALK_IN_ANYTIME_HEADER: 'walk-in-anytime-header',
  WALK_IN_ANYTIME_DESCRIPTION: 'walk-in-anytime-description',

  // Upsale
  UPSALE_PANEL_CONTAINER: 'upsale-panel-container',
  UPSALE_CONTENT_TITLE: 'upsale-content-title',
  UPSALE_ADD_TO_BAG_BTN: 'upsale-addToBag',

  // Modals
  CHANGE_FABRIC_MODAL: 'change-fabric-summary-modal',
  OOS_FABRIC_MODAL: 'summary-oos-fabric-modal',
  ADD_TO_BAG_FAILED_MODAL: 'add-to-bag-failed-modal',

  // Extra product
  EXTRA_PRODUCT_BANNER: 'extra-product-banner',
  EXTRA_PRODUCT_ADDED_MODAL: 'extra-product-added-modal-summary',
  REMOVE_PRODUCT_MODAL: 'remove-product-modal-summary',
  CHANGE_STYLE_PRESET_MODAL: 'summary-change-style-preset-modal',
  OPTION_GROUP_LIST: 'summary-option-group-list',
} as const;

export const SUMMARY_SECTION_TEST_IDS = {
  TITLE: 'summary-section-title',
  REMOVE_EXTRA_CONFIG: 'summary-section-remove-extra-config',
  EDIT: 'summary-section-edit',
  SEE_ALL_DETAILS: 'summary-section-seeAllDetails',
  getSectionId: (section: string) => `${section}-summary-section`,
} as const;

export const FABRIC_DETAILS_TEST_IDS = {
  IMAGE: 'summary-fabric-image',
  SWATCH: 'summary-fabric-swatch',
  SWATCH_ZOOM: 'summary-fabric-swatch-zoom',
  HEADER: 'summary-fabric-header',
  COMPOSITION: 'summary-fabric-composition',
  WOVEN_BY: 'summary-fabric-wovenby',
  CODE: 'summary-fabric-code',
  SEASON: 'summary-fabric-season',
  WEIGHT: 'summary-fabric-weight',
  BOOKLET_AND_SLIDERS: 'summary-fabric-bookletAndSliders',
  SEE_ALL_DETAILS: 'summary-fabric-seeAllDetails',
} as const;

export const SAVE_AND_SHARE_TEST_IDS = {
  SUCCESS_MSG: 'save-successfull-msg',
  ERROR_MSG: 'save-error-msg',
} as const;

